import {DateTimeIsoString} from '@aviary/store/common/common.types';

export const ORGANIZATION_FEATURE_KEY = 'organization';

export type OpacCustomTextKey = 'REGISTRATION_CONFIRMATION_MESSAGE' | 'PATRON_ITEM_REQUEST_ADDITIONAL_INSTRUCTIONS';

export interface Organization {
  readonly copyOverrides: Readonly<Partial<Record<OpacCustomTextKey, string>>>;
  readonly id: number;
  readonly googleStaffTenantId: string;
  readonly googlePatronTenantId: string;
  readonly name: string;
  readonly slug: string;
  readonly websiteUrl: string;
  readonly navigationLinks: GlobalNavLink[];
  readonly staffUrl: string;
  readonly opacUrl: string;
  readonly iconUrl: string;
  readonly bannerUrl: string;
  readonly manualAddressVerificationUrl: string;
  readonly policyUrl: string;
  readonly invitationEmail: string;
  readonly contactEmail: string;
  readonly arcgisBoundaryUrl: string;
  readonly phoneNumber: string;
  readonly hooplaLibraryId: number;
  readonly coverImageSource: CoverImageSource;
  readonly usesMEL: boolean;
  readonly active: boolean;
  readonly created: DateTimeIsoString;
  readonly modified: DateTimeIsoString;
  readonly novelistProfile: string;
  readonly novelistPassword: string;

  readonly demoOrganization: boolean;
  readonly demoStaffUsername: string;
  readonly demoStaffPassword: string;
  readonly demoOpacUsername: string;
  readonly demoOpacPassword: string;
}

export type CoverImageSource = 'CHILIFRESH' | 'BOWKER';

export interface GlobalNavLink {
  readonly label: string;
  readonly href: string;
}
